"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDrillInContent = exports.SelectDrillInFooter = exports.SelectDrillInHeader = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../../");
var utils_1 = require("../utils");
var utilities_1 = require("../../../utilities");
var SelectDrillInHeader = function (_a) {
    var className = _a.className, onBack = _a.onBack, title = _a.title, closeSelectHandler = _a.closeSelectHandler, preventFocus = _a.preventFocus;
    var SelectDrillInHeaderClassNames = classnames_1.default(className, 'SelectDrillIn__header');
    var focusContext = react_1.default.useContext(utils_1.FocusContext);
    var focusDispatch = focusContext.focusDispatch;
    var backButtonRef = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        var _a;
        if (!preventFocus)
            (_a = backButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [backButtonRef, preventFocus]);
    var handleKeyDown = function (e) {
        if (e.key === utilities_1.keys.enter || e.key === utilities_1.keys.esc) {
            onBack(e);
            focusDispatch({
                type: utils_1.FocusActionType.SetFocus,
                payload: { filterFocus: true },
            });
            return;
        }
        if (e.key === utilities_1.keys.tab && e.shiftKey) {
            onBack(e);
            closeSelectHandler();
        }
    };
    return (react_1.default.createElement(__1.Stack, { className: SelectDrillInHeaderClassNames, alignItems: "center" },
        react_1.default.createElement("span", { className: "Select__focus", tabIndex: 0, ref: backButtonRef, onKeyDown: handleKeyDown },
            react_1.default.createElement(__1.Icon, { className: "BackLink__back-icon cursor-pointer SelectDrillIn__back", name: "chevron_left", onClick: onBack, size: "20px" })),
        title && (react_1.default.createElement(__1.BodyText, { className: "SelectDrillIn__title ff-display lh-1 ta-center flex-grow-1", bold: true, size: "small" }, title))));
};
exports.SelectDrillInHeader = SelectDrillInHeader;
var SelectDrillInFooter = function (_a) {
    var footerActionName = _a.footerActionName, footerOnActionClick = _a.footerOnActionClick, closeSelectHandler = _a.closeSelectHandler, onBack = _a.onBack;
    var SelectDrillInFooterClassNames = classnames_1.default('AnvilDropdown__footer w-100');
    var hasAction = !!(footerActionName && footerOnActionClick);
    var handleKeyDown = function (e) {
        if (e.key === utilities_1.keys.enter) {
            footerOnActionClick(e);
            return;
        }
        if (e.key === utilities_1.keys.tab && !e.shiftKey) {
            onBack(e);
            closeSelectHandler();
        }
    };
    if (!hasAction) {
        return null;
    }
    return (react_1.default.createElement(__1.Stack, { alignItems: "center", justifyContent: "flex-end", className: SelectDrillInFooterClassNames },
        react_1.default.createElement(__1.Button, { primary: true, xsmall: true, onClick: footerOnActionClick, className: "Select__focus", tabIndex: 0, onKeyDown: handleKeyDown }, footerActionName)));
};
exports.SelectDrillInFooter = SelectDrillInFooter;
var SelectDrillInContent = function (_a) {
    var className = _a.className, content = _a.content;
    return react_1.default.createElement("div", { className: className }, content);
};
exports.SelectDrillInContent = SelectDrillInContent;
//# sourceMappingURL=DrillIn.js.map